// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3XOj5","row":"styles_row__12Rr5"};